/**
 * Tiny re-export so `@/ui` doesn't reach into a third-party package directly.
 * If we ever swap classnames → clsx the change happens here only.
 */
import classnames, { Argument } from "classnames";

export const cx = (...args: Argument[]): string => classnames(...args);
export type { Argument as CxArg };
